import React, { Component, Fragment } from 'react';
import Breadcumb from '../../../components/Breadcumb/Breadcumb';
import { GetUsers } from '../../../helpers';

//material ui
import { Container } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Users",
        page_path: "/app/users",
        icon: "circle",
    }
]
export default class SingleUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            user: null,
            parrent_user: null,
            allRoles: [],
            roles: [],
            isAdmin:false
        }
    }
     findArrayElementByName = (name) =>{
        return this.state.roles.find((element) => {
          return element === name;
        })
      }
    getData = async () => {
        let user_id = this.props.match.params.id;
        let resp = await GetUsers.getSingleUser(user_id);
        if (resp) {
          console.log(resp);
            if (resp.status === true) {
                this.setState({
                    isLoading: false,
                    user: resp.user,
                    parrent_user: resp.parent_user,
                    roles: resp.roles,
                    allRoles: resp.allRoles
                }, () =>{
                    this.setState({
                        isAdmin:this.findArrayElementByName('ROLE_ADMIN') === undefined ? false : true
                    })
                })
            } else {
                this.setState({
                    isLoading: true,

                })
            }

        }
    }
    handleChangeCheckbox =   (e) =>{
      const { user } = this.state;
      this.setState({
        isAdmin:!this.state.isAdmin
      }, async ()=>{

          const data = {
              user_id:user.id,
              isAdmin:this.state.isAdmin
          }
          let resp = await GetUsers.setUserRoles(data);
          if(resp){
            if(resp.status === true){
              
               window.location.reload();
            }
          }

      })
    }
    componentDidMount() {
        this.getData();
    }

    render() {
        const { isLoading, user, parrent_user, roles, isAdmin } = this.state;
      
        return (
            <Fragment>
                <Breadcumb items={BreadcrumbData} />
                <div className="page-wrapper mt20">
                    <Container >
                        {
                            isLoading ? 'Data Loading...' : <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <Card className={``}>
                                        <CardContent>
                                            <Typography variant="h5" component="h5">
                                                User Details
                                            </Typography>
                                            <p>Name : {user.fname} {user.lname}</p>
                                            <p>Email : {user.email}</p>
                                            <p>Mobile Number : {user.mobile_number} </p>
                                            <p>Gender : {user.gender}</p>
                                            <p>Date of Birth : {user.dob}</p>
                                            <p>Address : {user.address}</p>
                                            <p>City : {user.city} </p>
                                            <p>State : {user.state} </p>
                                            <p>Country : {user.country} </p>
                                           
                                            
                                            {parrent_user !== null ? <>
                                                <p>Parent User Referral : {parrent_user.referral_code}</p>
                                                <p>Parent User : {parrent_user.user_details.fname} {parrent_user.user_details.lname}</p>
                                            </> : null}

                                            <div className={`status-pills ml0 ${user.is_active ? "pills-success" : "pills-close"}`}> {user.is_active ? 'Active' : 'Inactive'}</div>

                                        </CardContent>
                                    </Card>
                                    <br />
                                   {
                                    user.referral_code ?  <Card className={``}>
                                        <CardContent>
                                            <Typography variant="h5" component="h5">
                                                Invite Users
                                            </Typography>
                                            <h3 style={{margin:"0px"}}>{user.referral_code.referral_code}</h3>
                                        </CardContent>
                                    </Card> : null
                                   }
                                </Grid>
                                <Grid item xs={6}>
                                <Card className={``}>
                                        <CardContent>
                                            <Typography variant="h5" component="h5">
                                                User Balance
                                            </Typography>
                                            <p>Total Balance : {user.balance.total_balance} </p>
                                            <p>Last Updated By : {user.balance.last_updated_by} </p>

                                        </CardContent>
                                    </Card>
                                    <br />
                                    <Card className={``}>
                                        <CardContent>
                                            <Typography variant="h5" component="h5">
                                                User Roles
                                            </Typography>
                                            {
                                                roles.map((item, i) => {
                                                    return <p key={i}>{item}</p>
                                                })
                                            }

                                        </CardContent>
                                    </Card>
                                    <br />
                                   {
                                    user.is_active ?  <Card className={``}>
                                        <CardContent>
                                            <Typography variant="h5" component="h5">
                                                Role Settings
                                            </Typography>
                                                 <FormControlLabel
                                                    control={
                                                        <Checkbox checked={isAdmin} onChange={this.handleChangeCheckbox}/>
                                                    }
                                                    label="ROLE_ADMIN"
                                                />
                                        </CardContent>
                                    </Card> : null
                                   }

                                  
                                   
                                </Grid>

                            </Grid>
                        }


                    </Container>
                </div>
            </Fragment>
        )
    }
}
